/*
 * Copyright (c) 2021. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import React, { useState } from "react";
import ButtonLoading from "../Button/ButtonLoading";
import Grid from "@mui/material/Grid";
import ValidatorSelect from "../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import useForm from "../../hooks/useForm";
import { formValue } from "../../services/formServiceFunctions";
import ApiClient from "../../services/ApiClient";
import { useSnackbar } from "notistack";

import { requiredFieldDefault } from "../../services/validationRules";

const DatevMonthlyPaymentsForm = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async ({ values }: { values: Record<string, any> }) => {
    setIsLoading(true);
    const data = await ApiClient.post("services/csv/create_datev_monthly_payments", { body: JSON.stringify(values) });
    let messageText = "Es wurde keine CSV Datei erstellt";
    if (data && data.status && data.electronicFileFolderId) {
      messageText = data.status === "ok" ? "Die CSV wurde erstellt" : "Die CSV kann nicht erstellt werden!";

      enqueueSnackbar(messageText, {
        variant: "custom",
        buttonText: "zur CSV Datei",
        buttonLink: "https://drive.google.com/drive/folders/" + data.electronicFileFolderId,
        linkIsExternal: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    }
    if (data && data.status && data.errorMessage) {
      messageText = data.status === "failed" ? data.errorMessage : "Die CSV kann nicht erstellt werden!";

      enqueueSnackbar(messageText, {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    }
    setIsLoading(false);
  };

  const { values, handleChange, handleSubmit } = useForm({
    initialValues: {
      month: "",
      year: "",
    },
    onSubmit,
  });

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} sx={{
        alignItems: "center"
      }}>
        <Grid
          size={{
            xs: 12,
            md: 3
          }} />
        <Grid
          size={{
            xs: 12,
            md: 3
          }}>
          <ValidatorSelect
            label={"Monat"}
            name={"month"}
            value={formValue(values, "month")}
            onChange={handleChange}
            validators={requiredFieldDefault}
          >
            <MenuItem value={1}>Januar</MenuItem>
            <MenuItem value={2}>Februar</MenuItem>
            <MenuItem value={3}>März</MenuItem>
            <MenuItem value={4}>April</MenuItem>
            <MenuItem value={5}>Mai</MenuItem>
            <MenuItem value={6}>Juni</MenuItem>
            <MenuItem value={7}>Juli</MenuItem>
            <MenuItem value={8}>August</MenuItem>
            <MenuItem value={9}>September</MenuItem>
            <MenuItem value={10}>Oktober</MenuItem>
            <MenuItem value={11}>November</MenuItem>
            <MenuItem value={12}>Dezember</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 3
          }}>
          <ValidatorSelect
            label={"Jahr"}
            name={"year"}
            value={formValue(values, "year")}
            onChange={handleChange}
            validators={requiredFieldDefault}
          >
            <MenuItem value={2024}>2024</MenuItem>
            <MenuItem value={2025}>2025</MenuItem>
            <MenuItem value={2026}>2026</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 3
          }}>
          <ButtonLoading
            isLoading={isLoading}
            disabled={isLoading}
            type={"submit"}
            color={"primary"}
            variant={"contained"}
            fullWidth={true}
          >
            CSV erstellen
          </ButtonLoading>
        </Grid>
      </Grid>
    </form>
  );
};

export default DatevMonthlyPaymentsForm;
